'use client'

import { usePathname } from 'next/navigation'
import Link from 'next/link'

export default function LanguageSwitcher({ currentLang }) {
  const pathname = usePathname()

  const getLocalizedPath = (targetLang) => {
    if (!pathname) return `/${targetLang}`
    // Ensure we are working with an absolute path
    const safePath = pathname.startsWith('/') ? pathname : `/${pathname}`
    const segments = safePath.split('/')
    // Replace the language segment (segments[1]) with the target language
    if (segments.length > 1) {
      segments[1] = targetLang
    }
    return segments.join('/')
  }

  return (
    <div className="lang-switcher">
      <span onClick={() => window.location.href = getLocalizedPath('en')} className={currentLang === 'en' ? 'active' : ''} style={{cursor: 'pointer'}}>EN</span> | 
      <span onClick={() => window.location.href = getLocalizedPath('vi')} className={currentLang === 'vi' ? 'active' : ''} style={{cursor: 'pointer'}}>VI</span> |
      <span onClick={() => window.location.href = getLocalizedPath('zh')} className={currentLang === 'zh' ? 'active' : ''} style={{cursor: 'pointer'}}>ZH</span> |
      <span onClick={() => window.location.href = getLocalizedPath('ko')} className={currentLang === 'ko' ? 'active' : ''} style={{cursor: 'pointer'}}>KO</span> |
      <span onClick={() => window.location.href = getLocalizedPath('ja')} className={currentLang === 'ja' ? 'active' : ''} style={{cursor: 'pointer'}}>JA</span>
    </div>
  )
}
